import { createEvent } from 'effector';

import { ProductManagementState } from './ProductManagementState';

export const productManagementEvent =
  createEvent<Partial<ProductManagementState>>('productManagementEvent');
